const yup = require('yup');

function deserializeValue(state) {
  if (Array.isArray(state.value)) {
    return state.value;
  }

  return state.value ? [state.value] : [];
}

module.exports = {
  getDefaultValue: () => [],
  serializeValue: (value) => ({ value }),
  deserializeValue,
  getDisplayValue: (...args) => {
    const files = deserializeValue(...args);

    return `${files.map((file) => file.name).join('\n')}\n\n`.trim() || '-';
  },
  validationSchema: ({ maxFiles }) => yup
    .array()
    .of(yup.mixed())
    .nullable()
    .max(maxFiles || 5, `Maximal ${maxFiles || 5} Dateien möglich.`),
};
